import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomList from '@/components/global/list/CustomList.jsx';
import { transactionListStyles } from '@/themes/commonStyles/transactionList.js';

const StyledTransactionListContent = styled(Box)(transactionListStyles);

export const StyledTransactionList = ({ children, ...props }) => (
    <CustomList {...props}>
        <StyledTransactionListContent className='responsive-table transaction-list'>{children}</StyledTransactionListContent>
    </CustomList>
);

StyledTransactionList.propTypes = {
    children: PropTypes.node,
};
